import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { GroupOption } from '@/types/metrics'

dayjs.extend(isSameOrBefore)
dayjs.extend(utc)
dayjs.extend(timezone)

export const convertToDate = (date: string, isStartDate = true) => {
  const today = new Date()
  let value = date !== 'start' && date !== 'end' ? new Date(date) : today

  if (isStartDate) {
    if (date === 'start') {
      value.setDate(value.getDate() - 14)
    }
    value.setHours(0, 0, 0)
  } else {
    // We keep the time as current time for when the date is "today" so that we can keep track of the hours
    if (date === 'end' || dayjs().isSame(value, 'day')) {
      value = today
    } else {
      value.setHours(23, 59, 59)
    }
  }
  return value
}

export const formatDate = (date: Date, tz: string) =>
  dayjs(date).tz(tz).format('YYYY-MM-DDTHH:mm:ss')

export const getNumberOfDaysBetweenDates = (start: Date, end: Date) => {
  const oneDay = 1000 * 60 * 60 * 24
  const diffInTime = end.getTime() - start.getTime()
  const diffInDays = Math.round(diffInTime / oneDay)
  return diffInDays
}

export const getEndDate = (startDate: Date, endDate: Date) => {
  if (getNumberOfDaysBetweenDates(startDate, endDate) > 6) {
    const newEndDate = new Date(startDate)
    newEndDate.setDate(newEndDate.getDate() + 6)
    newEndDate.setHours(23, 59, 59)
    return newEndDate
  }
  return null
}

export const getIsEnabled = (
  startDate: Date,
  endDate: Date,
  groupedBy: GroupOption,
) => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  tomorrow.setHours(0, 0, 0, 0)

  let enabled =
    startDate < tomorrow && endDate >= startDate && endDate < tomorrow

  if (groupedBy === 'hour') {
    const dayAfterEndValidDate = new Date(startDate)
    dayAfterEndValidDate.setDate(dayAfterEndValidDate.getDate() + 7)
    dayAfterEndValidDate.setHours(0, 0, 0, 0)
    enabled = enabled && endDate < dayAfterEndValidDate
  }

  return enabled
}

export const getConvertedDatesByGroup = ({
  startDate,
  endDate,
  groupedBy,
}: {
  startDate?: Date
  endDate?: Date
  groupedBy: GroupOption
}) => {
  switch (groupedBy) {
    case 'month':
      return {
        startDate: startDate
          ? new Date(startDate.getFullYear(), startDate.getMonth(), 1)
          : undefined,
        endDate: endDate
          ? new Date(
              endDate.getFullYear(),
              endDate.getMonth() + 1,
              0,
              23,
              59,
              59,
            )
          : endDate,
      }
    case 'year':
      return {
        startDate: startDate ? new Date(startDate.getFullYear(), 0) : undefined,
        endDate: endDate
          ? new Date(endDate.getFullYear(), 11, 31, 23, 59, 59)
          : undefined,
      }
    default:
      return {
        startDate,
        endDate,
      }
  }
}

export function getYesterday(endOfDay = false, tz = 'America/Denver'): Date {
  const yesterday = dayjs().tz(tz).subtract(1, 'day')
  return yesterday[endOfDay ? 'endOf' : 'startOf']('day').toDate()
}

export function convertRangeValueToDates(rangeValue: string) {
  const startDate = getYesterday()
  const endDate = getYesterday(true)

  switch (rangeValue) {
    case '1day':
      break
    case '2days':
      startDate.setDate(startDate.getDate() - 1)
      break
    case '3days':
      startDate.setDate(startDate.getDate() - 2)
      break
    case '1week':
      startDate.setDate(startDate.getDate() - 6)
      break
    case '2weeks':
      startDate.setDate(startDate.getDate() - 13)
      break
    case '1month':
      startDate.setMonth(startDate.getMonth() - 1)
      break
    default:
      break
  }

  return {
    startDate,
    endDate,
  }
}
